import React from 'react';
import { Outlet } from 'react-router-dom';

import classnames from 'classnames/bind';

import Header from '@COMPONENTS/HEADERS/Header';
import MainHeader from '@COMPONENTS/HEADERS/MainHeader';
import ModernAdminBreadcrumbs from '@COMPONENTS/HEADERS/breadcrumbs/ModernAdminBreadcrumbs';
import DrawersContainer from '@APP/DrawersContainer';

import styles from './EditDocument.module.scss';

const cx: CX = classnames.bind(styles);

function EditDocumentLayout() {
    return (
        <>
            <Header>
                <MainHeader />
                <ModernAdminBreadcrumbs />
            </Header>

            <main className={cx('main')}>
                <Outlet />
            </main>

            <DrawersContainer />
        </>
    );
}

export default EditDocumentLayout;
